import { render, staticRenderFns } from "./NewDSelectPreview.vue?vue&type=template&id=74606a3c&"
import script from "./NewDSelectPreview.vue?vue&type=script&lang=js&"
export * from "./NewDSelectPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDSelectPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports